// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  tokenMode: true,
  production: true,
  mono: true,
  demo: false,
  timeTracker: true,
  overRideHost: false,
  overRidePort: false,
  globalErrorRouting: false,
  applicationId: 'nbu',
  applicationSource: 'BACKOFFICENBU',
  // deviceId: '115210527',  //for Mono
  enableInterfaceEndpoints: false,
  extractAppointeeFromPolicy: true,
  enableABSLIInterfaceEndpoints: false,
  enableDashboardLocalDev:false,
  dashboardLocalUrl:"https://product-dev-services.metamorphosys.co.in",
  //extractAssigneeFromPolicy: true,
  //APIMasterEndpoint: null,
  // serverHost: "product.centralindia.cloudapp.azure.com",
  // serverHost: "sdemo.eastus.cloudapp.azure.com",
  // serverHost: "52.66.202.14",
  // serverHost: "13.234.239.158",
  // serverHost: "dev-bsli.metamorphosys.co.in",
  // serverHost: "absli-dev.metamorphosys.co.in", // UAT
  serverHost: "product-dev-services.metamorphosys.co.in", // Internal
  // serverHost: "0005bcd8.ngrok.io",
  // serverHost: "mms-uat.sompo.co.id",
  hardcodedMenu: false,
  dummyDashboard: false,
  showAPIlog: true,
  // tokenServerContext: "/MMSCLAIMS/",
  serverContext: "/MMSBackOffice/",
  serverContextPath: "/ClaimsPortal/",
  loginServerContext: "/",
  tokenServerContext: "/",
  secondaryTokenServerContext: "",
  fwaServerHost: 'product-demo-fwa-life-claim.metamorphosys.co.in',
  landingRoute: '/login',
  getConfigPathWithContext:false,
  // port: "8080",
  port: "80",
  // loginContext: { username: "ADJ", password: "admin" },
  SERVERERRORMSG: "Unexpected error occurred. Please try again later or contact your system administrator.",
  client_id : "mgHwIATApEZxcb5BpM8p",
  redirect_uri_with_investigator :  "" ,
  redirect_uri_without_investigator :  "",
  configPath : "/configs/health-nbu-transaction.json", 
  resourceContext : "/",
  isInvestigatorModule:true,
  version: "1.0.31",
  MFALogin: false,
  lookupDataLogger: false,
  monoMasterTokenServerContext: 'user-service',

  // landingRoute: '/login',
  loginURL: "https://product-dev-services.metamorphosys.co.in/#/login",
  // loginURL: "https://absli-dev-internal.metamorphosys.co.in/dev/life/claims/login",
  claimsUiURL: "https://absli-claims-dev-internal.metamorphosys.co.in/",
  authenticatorUiURL: "https://absli-authenticator-dev-internal.metamorphosys.co.in/",
  MMS_SSO_URL: "https://absli-dev.metamorphosys.co.in/dev/life/claims/oauth2/authorization/custom",
  featureFlags: {
    enableFutureEventDates: false
  }
}


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
